/* OviNova — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esEditor = document.documentElement.classList.contains('shopify-design-mode');

  /* ---------- Partir titulares en palabras para la entrada ---------- */
  function partirTexto(raiz) {
    if (raiz.dataset.ovPartido) return;
    raiz.dataset.ovPartido = '1';
    var i = 0;
    (function recorrer(nodo) {
      Array.prototype.slice.call(nodo.childNodes).forEach(function (hijo) {
        if (hijo.nodeType === 3) {
          var trozos = hijo.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          trozos.forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(' ')); return; }
            var p = document.createElement('span');
            p.className = 'ov-palabra';
            var dentro = document.createElement('span');
            dentro.style.setProperty('--i', i++);
            dentro.textContent = t;
            p.appendChild(dentro);
            frag.appendChild(p);
          });
          hijo.parentNode.replaceChild(frag, hijo);
        } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR') {
          recorrer(hijo);
        }
      });
    })(raiz);
  }

  /* ---------- Observador único de entradas ---------- */
  var observador = null;
  function initEntradas(ambito) {
    var sel = '[data-ov-reveal], .ov-split, .ov-revelar-img, .ov-cifra, [data-ov-count], .ov-comp__visor';
    var els = (ambito || document).querySelectorAll(sel);
    if (!els.length) return;
    (ambito || document).querySelectorAll('.ov-split').forEach(partirTexto);
    if (reducido || esEditor || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ov-visible'); if (el.hasAttribute('data-ov-count')) contar(el, true); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.classList.add('ov-visible');
          if (el.hasAttribute('data-ov-count')) contar(el);
          if (el.classList.contains('ov-comp__visor')) pistaComparador(el);
          observador.unobserve(el);
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  /* ---------- Cifras que cuentan ---------- */
  function contar(el, directo) {
    var fin = parseFloat(el.getAttribute('data-ov-count')) || 0;
    var dec = (String(el.getAttribute('data-ov-count')).split('.')[1] || '').length;
    var dur = parseInt(el.getAttribute('data-ov-dur') || '1800', 10);
    var salida = el.querySelector('[data-ov-valor]') || el;
    var fmt = function (v) { return v.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec }); };
    if (directo || reducido) { salida.textContent = fmt(fin); return; }
    var t0 = null;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 4);
      salida.textContent = fmt(fin * e);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  /* ---------- Parallax suave ---------- */
  var capasParallax = [];
  function initParallax() {
    capasParallax = Array.prototype.slice.call(document.querySelectorAll('[data-ov-parallax]'));
    if (!capasParallax.length || reducido) return;
    var pendiente = false;
    function pintar() {
      pendiente = false;
      var vh = window.innerHeight;
      capasParallax.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var f = parseFloat(el.getAttribute('data-ov-parallax')) || 0.1;
        var centro = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (centro * -f).toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }, { passive: true });
    window.addEventListener('resize', pintar);
    pintar();
  }

  /* ---------- Comparador antes / después ---------- */
  function initComparador() {
    document.querySelectorAll('.ov-comp__visor').forEach(function (v) {
      if (v.dataset.ovListo) return;
      v.dataset.ovListo = '1';
      var asa = v.querySelector('.ov-comp__asa');
      var arrastrando = false;
      function mover(x) {
        var r = v.getBoundingClientRect();
        var p = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
        v.classList.remove('ov-pista');
        v.style.setProperty('--pos', p + '%');
        if (asa) asa.setAttribute('aria-valuenow', Math.round(p));
      }
      v.addEventListener('pointerdown', function (e) { arrastrando = true; v.setPointerCapture(e.pointerId); mover(e.clientX); });
      v.addEventListener('pointermove', function (e) { if (arrastrando) mover(e.clientX); });
      v.addEventListener('pointerup', function () { arrastrando = false; });
      v.addEventListener('pointercancel', function () { arrastrando = false; });
      if (asa) asa.addEventListener('keydown', function (e) {
        var actual = parseFloat(getComputedStyle(v).getPropertyValue('--pos')) || 50;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          var n = Math.max(0, Math.min(100, actual + (e.key === 'ArrowLeft' ? -5 : 5)));
          v.style.setProperty('--pos', n + '%');
          asa.setAttribute('aria-valuenow', Math.round(n));
        }
      });
    });
  }
  function pistaComparador(v) {
    if (reducido || v.dataset.ovPista) return;
    v.dataset.ovPista = '1';
    var inicio = parseFloat(v.getAttribute('data-inicio')) || 50;
    v.classList.add('ov-pista');
    var pasos = [inicio - 22, inicio + 18, inicio];
    pasos.forEach(function (p, i) {
      setTimeout(function () { if (v.classList.contains('ov-pista')) v.style.setProperty('--pos', p + '%'); }, 500 + i * 1300);
    });
    setTimeout(function () { v.classList.remove('ov-pista'); }, 500 + pasos.length * 1300 + 200);
  }

  /* ---------- Carrusel de usos (flechas en móvil) ---------- */
  function initUsos() {
    document.querySelectorAll('[data-ov-usos]').forEach(function (s) {
      var pista = s.querySelector('.ov-usos__pista');
      s.querySelectorAll('[data-ov-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var tarjeta = pista.querySelector('.ov-uso');
          var paso = tarjeta ? tarjeta.getBoundingClientRect().width + 16 : 300;
          pista.scrollBy({ left: paso * parseInt(b.getAttribute('data-ov-dir'), 10), behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- Pasos: línea de progreso con el scroll ---------- */
  function initPasos() {
    var listas = document.querySelectorAll('.ov-pasos__lista');
    if (!listas.length) return;
    var pendiente = false;
    function pintar() {
      pendiente = false;
      var vh = window.innerHeight;
      listas.forEach(function (lista) {
        var r = lista.getBoundingClientRect();
        var p = Math.max(0, Math.min(1, (vh * 0.78 - r.top) / (r.height * 0.9)));
        if (reducido || esEditor) p = 1;
        lista.style.setProperty('--progreso', p.toFixed(3));
        var pasos = lista.querySelectorAll('.ov-paso');
        pasos.forEach(function (paso, i) {
          paso.classList.toggle('ov-activo', p >= (i / Math.max(pasos.length - 1, 1)) - 0.02 && p > 0.02);
        });
      });
    }
    window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }, { passive: true });
    pintar();
  }

  /* ---------- Selector de colores de la portada ---------- */
  function initColores() {
    document.querySelectorAll('[data-ov-colores]').forEach(function (s) {
      var botones = s.querySelectorAll('.ov-color');
      var imgs = s.querySelectorAll('.ov-colores__visor img');
      var cta = s.querySelector('[data-ov-colores-cta]');
      var ctaTxt = s.querySelector('[data-ov-colores-cta-texto]');
      botones.forEach(function (b, i) {
        b.addEventListener('click', function () {
          botones.forEach(function (x) { x.classList.remove('ov-activa'); x.setAttribute('aria-pressed', 'false'); });
          imgs.forEach(function (x) { x.classList.remove('ov-activa'); });
          b.classList.add('ov-activa');
          b.setAttribute('aria-pressed', 'true');
          if (imgs[i]) imgs[i].classList.add('ov-activa');
          if (cta && b.dataset.url) cta.href = b.dataset.url;
          if (ctaTxt && b.dataset.cta) ctaTxt.textContent = b.dataset.cta;
        });
      });
    });
  }

  /* ---------- FAQ con apertura suave ---------- */
  function initFaq() {
    document.querySelectorAll('.ov-faq__item, .ov-prod__acordeon details').forEach(function (d) {
      if (d.dataset.ovListo) return;
      d.dataset.ovListo = '1';
      var resumen = d.querySelector('summary');
      var cuerpo = resumen && resumen.nextElementSibling;
      if (!cuerpo || reducido || !cuerpo.animate) return;
      resumen.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          var h = cuerpo.offsetHeight;
          var a = cuerpo.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 450, easing: 'cubic-bezier(.65,0,.35,1)' });
          a.onfinish = function () { d.open = false; };
        } else {
          d.open = true;
          var h2 = cuerpo.offsetHeight;
          cuerpo.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 550, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function formatoDinero(cents, formato) {
    var v = (cents / 100).toFixed(2);
    var conComa = v.replace('.', ',');
    if (!formato) return conComa + ' €';
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, tipo) {
      if (tipo === 'amount') return v;
      if (tipo === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (tipo === 'amount_with_comma_separator') return conComa;
      if (tipo === 'amount_no_decimals_with_comma_separator') return Math.round(cents / 100).toString();
      return conComa;
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-ov-producto]').forEach(function (raiz) {
      if (raiz.dataset.ovListo) return;
      raiz.dataset.ovListo = '1';
      var datos = {};
      try { datos = JSON.parse(raiz.querySelector('[data-ov-producto-json]').textContent); } catch (e) { return; }
      var formato = raiz.getAttribute('data-formato');

      // Galería
      var principales = raiz.querySelectorAll('.ov-prod__principal img');
      var minis = raiz.querySelectorAll('.ov-prod__mini');
      var actual = 0;
      function verFoto(i) {
        if (!principales.length) return;
        actual = (i + principales.length) % principales.length;
        principales.forEach(function (img, n) { img.classList.toggle('ov-activa', n === actual); });
        minis.forEach(function (m, n) { m.classList.toggle('ov-activa', n === actual); m.setAttribute('aria-current', n === actual ? 'true' : 'false'); });
        if (minis[actual]) minis[actual].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      minis.forEach(function (m, n) { m.addEventListener('click', function () { verFoto(n); }); });
      raiz.querySelectorAll('[data-ov-foto]').forEach(function (b) {
        b.addEventListener('click', function () { verFoto(actual + parseInt(b.getAttribute('data-ov-foto'), 10)); });
      });
      var visor = raiz.querySelector('.ov-prod__principal');
      if (visor) {
        var x0 = null;
        visor.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        visor.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) verFoto(actual + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      // Variantes
      var form = raiz.querySelector('form[action*="/cart/add"]');
      var inputId = form && form.querySelector('input[name="id"]');
      var boton = raiz.querySelector('[data-ov-anadir]');
      var botonTxt = raiz.querySelector('[data-ov-anadir-texto]');
      var precio = raiz.querySelectorAll('[data-ov-precio]');
      var antes = raiz.querySelector('[data-ov-precio-antes]');
      var ahorro = raiz.querySelector('[data-ov-ahorro]');
      var etiquetaValor = raiz.querySelectorAll('[data-ov-valor-elegido]');
      function aplicarVariante() {
        var elegidas = [];
        raiz.querySelectorAll('.ov-prod__opcion').forEach(function (fs, n) {
          var marcado = fs.querySelector('input:checked');
          elegidas[n] = marcado ? marcado.value : null;
          if (etiquetaValor[n] && marcado) etiquetaValor[n].textContent = marcado.value;
        });
        var v = (datos.variants || []).find(function (x) {
          return x.options.every(function (o, n) { return elegidas[n] === null || o === elegidas[n]; });
        });
        if (!v) {
          if (boton) boton.disabled = true;
          if (botonTxt) botonTxt.textContent = raiz.getAttribute('data-txt-nodisponible');
          return;
        }
        if (inputId) inputId.value = v.id;
        precio.forEach(function (p) { p.textContent = formatoDinero(v.price, formato); });
        if (antes) {
          var hay = v.compare_at_price && v.compare_at_price > v.price;
          antes.hidden = !hay;
          if (hay) antes.textContent = formatoDinero(v.compare_at_price, formato);
          if (ahorro) {
            ahorro.hidden = !hay;
            if (hay) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
          }
        }
        if (boton) boton.disabled = !v.available;
        if (botonTxt) botonTxt.textContent = v.available ? raiz.getAttribute('data-txt-anadir') : raiz.getAttribute('data-txt-agotado');
        if (v.featured_media && v.featured_media.id) {
          var idx = Array.prototype.findIndex.call(principales, function (img) { return img.getAttribute('data-media-id') == v.featured_media.id; });
          if (idx > -1) verFoto(idx);
        }
        if (window.history && window.history.replaceState && raiz.hasAttribute('data-actualizar-url')) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      raiz.querySelectorAll('.ov-prod__opcion input').forEach(function (i) { i.addEventListener('change', aplicarVariante); });

      // Cantidad
      var cant = raiz.querySelector('.ov-prod__cantidad input');
      raiz.querySelectorAll('[data-ov-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-ov-cant'), 10));
          cant.value = n;
        });
      });

      // Añadir al carrito sin salir de la página
      var error = raiz.querySelector('.ov-prod__error');
      if (form && window.fetch) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (boton) boton.setAttribute('aria-busy', 'true');
          if (error) error.textContent = '';
          var fd = new FormData(form);
          fd.append('sections', 'cart-icon-bubble');
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (boton) boton.removeAttribute('aria-busy');
              if (!res.ok) { if (error) error.textContent = res.j.description || res.j.message || 'No se ha podido añadir.'; return; }
              var burbuja = document.getElementById('cart-icon-bubble');
              if (burbuja && res.j.sections && res.j.sections['cart-icon-bubble']) {
                var tmp = document.createElement('div');
                tmp.innerHTML = res.j.sections['cart-icon-bubble'];
                var nuevo = tmp.querySelector('.shopify-section') || tmp;
                burbuja.innerHTML = nuevo.innerHTML;
              }
              avisoCarrito(raiz);
            })
            .catch(function () { if (boton) boton.removeAttribute('aria-busy'); form.submit(); });
        });
      }

      // Barra fija de compra
      var barra = raiz.querySelector('.ov-prod__barra');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { barra.classList.toggle('ov-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(boton);
        var botonBarra = barra.querySelector('button');
        if (botonBarra) botonBarra.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
    });
  }

  function avisoCarrito(raiz) {
    var aviso = document.querySelector('.ov-aviso');
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'ov-aviso';
      aviso.setAttribute('role', 'status');
      document.body.appendChild(aviso);
    }
    var raizUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    aviso.innerHTML = '<span class="ov-aviso__ok">✓</span><span>' + (raiz.getAttribute('data-txt-anadido') || 'Añadido al carrito') + '</span>' +
      '<a class="ov-aviso__link" href="' + raizUrl + 'cart">' + (raiz.getAttribute('data-txt-vercarrito') || 'Ver carrito') + '</a>' +
      '<a class="ov-aviso__pagar" href="' + raizUrl + 'checkout">' + (raiz.getAttribute('data-txt-pagar') || 'Pagar') + '</a>';
    requestAnimationFrame(function () { aviso.classList.add('ov-visible'); });
    clearTimeout(aviso._t);
    aviso._t = setTimeout(function () { aviso.classList.remove('ov-visible'); }, 6000);
  }

  function initTodo(ambito) {
    initEntradas(ambito);
    initParallax();
    initComparador();
    initUsos();
    initPasos();
    initColores();
    initFaq();
    initProducto();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();

  // En el editor de Shopify, reactivar al recargar una sección
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
